import { render } from "./AppMenu.vue?vue&type=template&id=4511d5ed&ts=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__